import { useQuery } from '@tanstack/react-query';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

export function useGetParentChildren(parentId: number | undefined) {
  return useQuery({
    queryKey: [ParentKey.PARENT_CHILDREN, parentId],
    queryFn: () => ParentService.getParentChildren(parentId as number).then((response) => response.data),
    enabled: typeof parentId === 'number',
  });
}
